import { keys } from './constants';

function checkClick(event) {
  /**
   * Check if the event is a click or enter/space from keyboard
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  if (!event) {
    console.warn('Missing event to checkClick');
    return false;
  }
  return (
    event.type === 'click' ||
    (event.type === 'keydown' && (event.keyCode === keys.space || event.keyCode === keys.enter))
  );
}

function openModalContent() {
	$('#main-content, #footer-content, #header-content').attr('aria-hidden', 'true');
}

function closeModalContent() {
	$('#main-content, #footer-content, #header-content').attr('aria-hidden', 'false');
}

function expandBM() {
	this.setAriaExpanded($('.booking-mask-form-container .js-trigger-open'), true);
}

function expandBySelectorBM(el) {
	this.setAriaExpanded(el, true);
}

function expandCheckingVisibilityBM() {
	if ($('.booking-mask-form-container.js-booking-mask-form > .visible-open').is(':visible')){
		this.expand();
	}
}

function shrinkBM() {
	this.setAriaExpanded($('.booking-mask-form-container .js-trigger-open'), false);
}

function shrinkBySelectorBM(el) {
	this.setAriaExpanded(el, false);
}

function setAriaExpandedBM(el, value) {
	el.attr('aria-expanded', value);
}

function removeInappropiateRoles() {
	$('#bm-calendars')
	.find('[role="heading"],[role="grid"]')
	.each(function() {
		$(this).removeAttr('role');
	});
}

function addLabelToValidationMessageForms(element, text) {
	let $element = $(element),
			$elementContainingTheLabelText;

	if ($element.is('select')) $elementContainingTheLabelText = $element.parent().prev();
	else if (['checkbox','radio'].includes($element.attr("type"))){
			$elementContainingTheLabelText = $element.closest('.form-group--horizontal, .form-group').find('legend:first')
	} else if ($element.attr("type") == 'file') {
			$elementContainingTheLabelText = $element.closest('.form-group').find('label:first')
	}
	else $elementContainingTheLabelText = $element.parent().find('label:first');

	let result = ($elementContainingTheLabelText.text().replace(/\*/g,'').replace(/ *\([^)]*\) */g, '').trim() + ' ' + text).trim();
	return result;
}

function addCurrentPageBreadcrumb() {
	$('.breadcrumb-container a:last').attr('aria-current', 'page');
}


export default {
	keys,
	checkClick,
	modalTypeContent: {
		open: openModalContent,
		close: closeModalContent
	},
	bookingMask: {
		expandables: {
			expand: expandBM,
			expandBySelector: expandBySelectorBM,
			expandCheckingVisibility: expandCheckingVisibilityBM,
			shrink: shrinkBM,			
			shrinkBySelector: shrinkBySelectorBM,
			setAriaExpanded: setAriaExpandedBM
		},
		roles: {
			removeInappropiate: removeInappropiateRoles,
		}
	},
	forms: {        
		addLabelToValidationMessage: addLabelToValidationMessageForms
	},
	breadcrumbs: {
		addCurrentPage: addCurrentPageBreadcrumb
	}
};
